import { motion } from "framer-motion";
import { MessageCircle, Camera, FileCheck2 } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Chapter } from "./shared";

const ICONS = [MessageCircle, Camera, FileCheck2];

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="section-alt">
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
        <Chapter title={t.how.title} sub={t.how.sub} />

        <ol className="relative grid gap-6 sm:gap-7 md:grid-cols-3">
          <div aria-hidden="true" className="pointer-events-none absolute left-[16.6%] right-[16.6%] top-12 hidden h-px bg-gradient-to-r from-transparent via-amber-400/40 to-transparent md:block" />
          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.li
                key={s.title}
                data-testid={`how-step-${i + 1}`}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="card-elevated card-lift group relative rounded-3xl p-7 sm:p-8"
              >
                <div className="flex items-center justify-between">
                  <span className="icon-tile flex h-14 w-14 items-center justify-center rounded-2xl text-amber-400">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </span>
                  <span className="font-heading text-5xl font-extrabold tracking-tight text-white/[0.07]">0{i + 1}</span>
                </div>
                <h3 className="mt-7 font-heading text-xl font-semibold tracking-[-0.02em]">{s.title}</h3>
                <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-400">{s.desc}</p>
              </motion.li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
